/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import useFilters from '../useFilters'
import { FormField } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { UltyDropdown } from '@ulty/ulty-ui'
import useFeature from '../../FeatureProvider/useFeature'

const DisputeStatusFilter = () => {
    const [t] = useTranslation()
    const {filters, setFilters} = useFilters()
    const { isEnabled } = useFeature()

    if (!isEnabled('disputes')) {
        return null
    }

    const handleDisputeStatusChange = (newStatus) => {
        const newFilters = {
            ...filters,
            disputeStatus: newStatus === '' ? undefined : newStatus,
        }

        setFilters(newFilters)
    }

    const statusOptions = [
        { text: t('dispute.filter.all'), key: '', value: '' },
        { text: t('dispute.status_values.OPEN'), key: 'OPEN', value: 'OPEN' },
        { text: t('dispute.status_values.CONTESTED'), key: 'CONTESTED', value: 'CONTESTED' },
        { text: t('dispute.status_values.RECOVERED'), key: 'RECOVERED', value: 'RECOVERED' },
        { text: t('dispute.status_values.PARTIALLY_RECOVERED'), key: 'PARTIALLY_RECOVERED', value: 'PARTIALLY_RECOVERED' },
        { text: t('dispute.status_values.REFUNDED'), key: 'REFUNDED', value: 'REFUNDED' },
    ]

    return (
        <UltyDropdown
            label={t('dispute.filter.title')}
            options={statusOptions}
            placeholder=' '
            value={filters.disputeStatus || ''}
            onChange={(e, dp) => handleDisputeStatusChange(dp.value)}
        />
    )
}

export { DisputeStatusFilter }
